import { Navigate } from "react-router-dom";

import useAuth from "@/hooks/useAuth";
import Loader from "../Loader";
import type { GuardProps } from "./types";

function AuthGuard({ children }: GuardProps) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) return <Loader />;
  if (!isAuthenticated) return <Navigate to="/" replace />;

  return <>{children}</>;
}

export default AuthGuard;
